import { type CoordinatorAutomationRead } from '@apps/web/components/automations/types';

export const WEEKDAY_LABELS: ReadonlyArray<string> = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
];

function formatClockTime(time: string): string {
    const [rawHour, rawMinute] = time.split(':');
    const hour = Number(rawHour);
    const minute = Number(rawMinute);
    if (!Number.isFinite(hour) || !Number.isFinite(minute)) {
        return time;
    }
    const period = hour >= 12 ? 'PM' : 'AM';
    return `${((hour + 11) % 12) + 1}:${String(minute).padStart(2, '0')} ${period}`;
}

export function automationScheduleSummary(
    automation: Pick<CoordinatorAutomationRead, 'schedule' | 'timezone'>,
): string {
    const time = formatClockTime(automation.schedule.time);
    if (automation.schedule.kind === 'daily') {
        return `Every day at ${time} (${automation.timezone})`;
    }
    const weekday =
        WEEKDAY_LABELS[automation.schedule.weekday ?? 0] ?? WEEKDAY_LABELS[0]!;
    return `Every ${weekday} at ${time} (${automation.timezone})`;
}

export function automationScheduleShortSummary(
    automation: Pick<CoordinatorAutomationRead, 'schedule'>,
): string {
    const time = formatClockTime(automation.schedule.time);
    if (automation.schedule.kind === 'daily') {
        return `Every day, ${time}`;
    }
    const weekday =
        WEEKDAY_LABELS[automation.schedule.weekday ?? 0] ?? WEEKDAY_LABELS[0]!;
    return `Every ${weekday}, ${time}`;
}
